import React from 'react';
import { styled } from '@mui/material/styles';
import { cloneDeep } from 'lodash';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import clsx from 'clsx';
import { withFormsy } from 'formsy-react';
import ChipSelect from './ChipSelect';

const PREFIX = 'CheckboxesFormsy';

const classes = {
  options: `${PREFIX}-options`,
  option: `${PREFIX}-option`
};

const StyledFormGroup = styled(FormGroup)((
  {
    theme
  }
) => ({
  [`& .${classes.options}`]: {
    marginTop: 10
  },

  [`& .${classes.option}`]: {
    marginLeft: 10
  }
}));

function CheckboxesFormsy(props) {

  // An error message is returned only if the component is invalid
  const { description, errorMessage, disabled, value, options, label, name, setValue } = props;
  const checkedList = value || [];

  function changeValue(val) {
    setValue(val);
  }

  const handleChange = (event) => {
    // setState({ ...state, [event.target.name]: event.target.checked });
    const checked = event.target.checked;
    const optionAlias = event.target.name;
    const newList = cloneDeep(checkedList);
    const index = checkedList.indexOf(optionAlias);
    if (checked && index < 0) {
      newList.push(optionAlias);
    } else if(!checked && index >= 0) {
      newList.splice(index, 1);
    }
    setValue(newList);
  };

  const renderCheckbox = (option, i) => {
    return (
      <div key={i} className={classes.option}>
        <FormControlLabel
          control={
            <Checkbox
              disabled={disabled}
              checked={checkedList.includes(option.value)}
              onChange={handleChange}
              name={option.value}
            />
          }
          label={option.label}
        />
      </div>
    );
  };

  const helperText = errorMessage || description;
  // const error = Boolean((!props.isPristine && props.showRequired) || errorMessage);
  return (
    <StyledFormGroup>
      {label && <InputLabel htmlFor={name}>{label}</InputLabel>}
      <div id={name} className={classes.options} >
        {options.map(renderCheckbox)}
      </div>
      {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </StyledFormGroup>
  );
}

export default React.memo(withFormsy(CheckboxesFormsy));
